export default {
    onboarding: import.meta.env.WEB2APP_URL,
    termsOfUse: 'https://legal.muscle-booster.io/page/terms-of-use',
    privacyPolicy: 'https://legal.muscle-booster.io/page/privacy-policy',
    refundPolicy: 'https://legal.muscle-booster.io/page/refund-policy',
};
